import { API_URL } from '../constants';

export async function fetchScreen(id) {
  return await fetch(`${API_URL}/screen/${id}`)
    .then(res => res.json())
    .then(res => res.data)
    .catch(error => console.error(error.message));
}
